import { atom } from "jotai";

export const listFormsAtom = atom<any[] | []>([]);
